import * as classnames from 'classnames'
import * as React from 'react'

type Theme = {[key: string]: string}

/**
 * Enhances the `Component` with the given `theme`.
 * Useful for combining multiple themes.
 * @param Component component with `theme` as a prop
 * @param theme mapping to `className`s
 */
export function composeTheme<P extends {theme?: T}, S, T extends {}>(
  Component: React.ComponentClass<P>, theme: T) {
  return class extends React.Component<P, S> {
    public render() {
      if (!this.props.theme) return <Component {...this.props} theme={theme} />
      const themeKeys = [...Object.keys(theme), ...Object.keys(this.props.theme)]
      const combinedTheme = themeKeys.reduce((t: {}, key: string) => ({
        ...t,
        [key]: classnames((theme as Theme)[key], (this.props.theme as Theme)[key]),
      }), {})
      return <Component {...this.props} theme={combinedTheme} />
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/theme-helpers.tsx